import gql from '../../stringGqlTag';

export const JOB_PROFILE_MODEL_FRAGMENT = gql`
  fragment JobProfileModelFragment on JobProfileModel {
    code
    name
    displayName
    uid
    status
    externalId
    mappedExportJobProfile {
      uid
    }
    classifications {
      uid
      name
    }
    jobFamily {
      name
      uid
    }
    description
    summary
    permissions
  }
`;
